const Notification = ({ message, action }) => (
  <div style={{ display: 'flex' }}>
    <div>{message}</div>
    <div>{action}</div>
  </div>
);

export default Notification;
